import { APIClient } from '@/services'
import { Question } from '@/types'
import { globalState } from '@codeleap/store'

export type PulseFrom = 'org_page' | 'act_page' | 'start_page' | 'onboarding_page' | 'auto_open' | 'newsfeed'

export type PulseState = {
  page: number
  answers: APIClient.Pulse.AnswerData[]
  answeredQuestions: Question['id'][]
  from: PulseFrom | null
  initialQuestions?: Question['id'][]
  shouldAutoOpen: boolean
  successOpen: boolean
}

const initialState: PulseState = {
  page: 0,
  answers: [],
  answeredQuestions: [],
  from: null,
  initialQuestions: undefined,
  shouldAutoOpen: false,
  successOpen: false,
}

export const PulseStore = globalState<PulseState>(initialState)

export const clearPulseStore = () => {
  PulseStore.set(initialState)
}
